import React, {useState, useContext} from "react";
import {useQueryClient} from "react-query";
import __ from "lodash";
import moment from "moment";
import axios from "axios";
import {IconButton, InputLabel, MenuItem, Select, Tooltip} from '@material-ui/core';
import {HighlightOff, Search} from '@material-ui/icons';
import SystemContext from "../../../SystemContext";
import { getApiSitePrefix } from "../../../functions/SiteDefaults";
import {ActionsList, CheckboxEditor, ComboSelect, DatePicker, MaskedText} from "../../../controls";

const apiSitePrefix = getApiSitePrefix();

const dateFormat = "DD/MM/YYYY";
const marginLeft = 10;
const formatChars={
  "A": ".",
  "9": "[0-9]",
}

const emptySearch = {
  fromDate: null,
  toDate: null,
  messageType: "",
  direction: "IN",
  sender: null,
  subject: null,
  error: false,
}


const MessageSelector = (props) => {
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const [search, setSearch] = useState({
    ...emptySearch,
    fromDate: moment.utc().toISOString(),
    toDate: moment.utc().toISOString(),
  });

  const delay = (milliseconds) => new Promise(resolve => {
    setTimeout(resolve, milliseconds);
  });

  const download = async (url, name) => {
    const a = document.createElement('a');
    a.download = name;
    a.href = url;
    a.style.display = 'none';
    document.body.append(a);
    a.click();

    // Chrome requires the timeout
    await delay(100);
    a.remove();
  };

  const handleSearch = () => {
    if (eventBus) {
      if (eventBus) {
        eventBus.trigger('MessageList.search',
          {
            fromDate: search.fromDate ? moment(search.fromDate).startOf("day").format("YYYY-MM-DDHHmmss") : "null",
            toDate: search.toDate ? moment(search.toDate).endOf("day").format("YYYY-MM-DDHHmmss") : "null",
            messageType: search.messageType||"null",
            direction: search.direction.toUpperCase(),
            sender: encodeURIComponent(search.sender)||"null",
            subject: encodeURIComponent(search.subject)||"null",
            error: search.error,
          }
        );
      }
    }
  }

  const handleClearSelections = () => {
    setSearch(emptySearch);
    if (eventBus) {
      eventBus.trigger('MessageList.search', {});
    }
  }


  // const actions = [
  //   {iconName: "assessment", iconProps: {color: "secondary"}, tooltip: "Trip Summary", disabled: tripRecord?.data?.tripUuid===undefined, onClick:()=>{eventBus.trigger('BookingQueueTrips.tripSummaryRequested', {})}},
  //   {iconName: "flight", iconProps: {color: "secondary"}, tooltip: "GHA Extract", disabled: tripRecord?.data?.tripUuid===undefined, onClick:()=>{downloadReport("GHA")}},
  //   {iconName: "account_balance", iconProps: {color: "secondary"}, tooltip: "Generate Accounting Extract", disabled: tripRecord?.data?.tripUuid===undefined, onClick:()=>{downloadReport("ACCOUNTING")}},
  //   {iconName: "receipt", iconProps: {color: "secondary"}, tooltip: "Invoice Backup", disabled: tripRecord?.data?.tripUuid===undefined, onClick:()=>{downloadReport("BACKUP")}}
  // ]


  // const renderActions = () => {
  //   if (actions && Array.isArray(actions)) {
  //     return (
  //       <>
  //         {actions.map((_action) => {
  //           let action = _action;
  //           if (typeof action === "function") {
  //             action = action(tripRecord);
  //           }
  //           if (typeof action.render === "function") {
  //             return action.render(tripRecord, action);
  //           }
  //           return (<IconButton {...__.omit(action, 'iconName')}><Icon {...action.iconProps}>{action.iconName}</Icon></IconButton>)
  //         })}
  //       </>
  //     )
  //   }
  //   return <></>
  // }


  return (
    <div style={{padding: "10px 20px", alignItems: "center",  justifyContent: "center",  width: "calc(100% - 20px)", display: "flex"}}>
      <ComboSelect
        style={{width: 150}}
        containerStyle={{width: 150}}
        label={"Message Type"}
        inputLabelProps={{ shrink: true }}
        group="MESSAGE TYPES"
        subGroup="SUPPORTED"
        fullWidth
        value={search.messageType}
        onChange={(value)=> {setSearch({...search, messageType: value})}}
      />
      <div style={{width: 70, marginRight: marginLeft}}>
        <InputLabel shrink id={`direction-label`} style={{position: "relative", marginBottom: 2, marginLeft: marginLeft}} >Direction</InputLabel>
        <Select
          style={{marginTop: -2, marginLeft: marginLeft}}
          value={search.direction}
          fullWidth
          onChange={e => {
            setSearch({...search, direction: e.target.value})
          }}
          MenuProps={{
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
          }}
        >
          {
            ["In", "Out"].map((item) => {
              return (<MenuItem key={item} value={item}>{item}</MenuItem>);
            })
          }
        </Select>
      </div>
      <DatePicker
        style={{width: 130, marginTop: -1, marginLeft: marginLeft}}
        value={search.fromDate}
        defaultValue={null}
        disableToolbar={true}
        label={"From Date"}
        autoOk={true}
        format={dateFormat}
        onChange={(value)=> {
          const fromDate = moment(value).toISOString();
          setSearch({...search, fromDate: fromDate});
        }}
      />
      <DatePicker
        style={{width: 130, marginTop: -1, marginLeft: marginLeft}}
        // initialValue={moment(search.fromDate, dateFormat).isAfter(moment(search.toDate, dateFormat)) ? moment(search.fromDate, dateFormat) : moment(search.toDate, dateFormat)}
        // minDate={moment(search.fromDate, dateFormat)}
        value={search.toDate}
        defaultValue={null}
        disableToolbar={true}
        label={"To Date"}
        autoOk={true}
        format={dateFormat}
        onChange={(value)=> {
          const toDate = moment(value).toISOString();
          setSearch({...search, toDate: toDate});
        }}
      />
      <div style={{width: 300, marginRight: marginLeft}}>
        <MaskedText
          style={{width: 300, marginTop: -1, marginLeft: marginLeft}}
          mask={"A".repeat(200)}
          forceUpperCase={false}
          formatChars={formatChars}
          label="Sender"
          inputLabelProps={{ shrink: true }}
          fullwidth
          value={search.sender}
          onChange={(value) => setSearch({...search, sender: value})}
        />
      </div>
      <div style={{width: 300, marginRight: marginLeft}}>
        <MaskedText
          style={{width: 300, marginTop: -1, marginLeft: marginLeft}}
          mask={"A".repeat(200)}
          forceUpperCase={false}
          formatChars={formatChars}
          label="subject"
          inputLabelProps={{ shrink: true }}
          fullwidth
          value={search.subject}
          onChange={(value) => setSearch({...search, subject: value})}
        />
      </div>
      <div style={{width: 90, marginLeft: marginLeft * 2}}>
        <InputLabel shrink id={`direction-label`} style={{position: "relative", marginBottom: 2, marginLeft: marginLeft}} >With Errors</InputLabel>
        <CheckboxEditor
          value={search.error}
          checked={search.error}
          onChange={ (checked) => {
            setSearch({...search, error: checked});
          }}
        />
      </div>
      <IconButton onClick={()=>{handleSearch()}}>
        <Tooltip title={"Click to retrieve messages"}>
          <Search style={{height: 32, width: 32, }} color="primary"/>
        </Tooltip>
      </IconButton>
      <IconButton onClick={()=>{handleClearSelections()}}>
        <Tooltip title={"Click to clear all selections"}>
          <HighlightOff style={{height: 32, width: 32, }} color="primary"/>
        </Tooltip>
      </IconButton>
      <div style={{ display: "block", marginLeft: "auto", marginRight: "0"}}>
        <ActionsList
          id={"action-list"}
          actions={[]}
        />
      </div>
    </div>
  )
}

export default MessageSelector;
